import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table, Form } from "react-bootstrap";
import trasportApi from "../../api/trasportApi";
import { ShimmerTable } from "react-shimmer-effects";
import Main from "../layout/Main";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import { Link } from "react-router-dom";
import InfoPill from "../InfoPill";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import { useNavigate } from "react-router-dom";
import { BsChevronRight } from "react-icons/bs";

const TrasportList = () => {
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState([]); // Initialize as an array
  const [tempBody, setTempBody] = useState([]);

  useEffect(() => {
    fetchAlItems();
  }, []);

  const fetchAlItems = () => {
    async function init() {
      const item = await trasportApi.fetchAllTransporters();
      if (item) {
        setBody(item);
        setTempBody(item);
      } else {
        setBody([]);
      }
    }
    init();
  };

  useEffect(() => {
    const fetchData = async () => {
      const fnYear = await trasportApi.fetchAllFinancialYears();
      if (fnYear && fnYear.length) {
        let ar = [];
        fnYear.forEach((item) => {
          ar.push({ value: item.id, label: item.name });
        });
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }
    };

    fetchData();
  }, []);

  const header = [
    { title: "Trasporter Name", prop: "transporter_name", isFilterable: true, cell: (row) => <Link to={"/transporters/" + row.id} state={row}>{row.transporter_name}</Link> },
    { title: "Contact Person", prop: "contact_person", isFilterable: true },
    { title: "Email", prop: "email", isFilterable: true },
    { title: "Phone", prop: "phone", isFilterable: true },
    { title: "City", prop: "city", isFilterable: true },
    { title: "District", prop: "district", isFilterable: true },
    { title: "State", prop: "state", isFilterable: true },
    { title: "Financial Year Name", prop: "financial_year_name", isFilterable: true },
    { title: "Createdby", prop: "createdbyname", isFilterable: true },
  ];

  const labels = {
    beforeSelect: " ",
  };

  const CreateTrasport = () => {
    navigate(`/transporters/e`);
  };

  const onFilterTypeYear = async (event) => {
    var arr = [];
    tempBody.forEach((item) => {
      if (item.financial_year_name === event.target.value) {
        arr.push(item);
      }
    });
    setBody(arr.length > 0 ? arr : tempBody);
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.SupplierList}</title>
        </Helmet>
      </>
      
      <Row className="g-0">
        <Col lg={2} className="mx-2">
          <Link to="/home" style={{ textDecoration: "none" }}>
            Home
          </Link>
          <BsChevronRight />
          Transport List
        </Col>
        <Col lg={12} className="p-lg-4">
          {body.length > 0 ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col xs={12} lg={4} className="d-flex flex-col justify-content-end align-items-end">
                  <Filter />
                </Col>
                <Col xs={12} sm={6} lg={4} className="d-flex flex-col justify-content-start align-items-center">
                <PaginationOptions labels={labels} style={{marginLeft :"14px"}}/>
                  <div style={{position: "absolute",marginLeft : "55px"}}>
                  
                  <InfoPill left="Total" right={body?.length} />
                  </div>
                  <Form.Group className="mx-3 mt-4" controlId="formBasicCourses">
                    <Form.Select aria-label="Enter Financial Year" name="financial_year_name" onChange={onFilterTypeYear} style={{marginLeft: "115px"}}>
                      <option value="">--Select Financial Year--</option>
                      <option value="">All</option>
                      {financialYearOption.map((option) => (
                        <option key={option.value} value={option.label}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} lg={4} className="d-flex flex-col justify-content-end align-items-end">
                  <Button className="btn-md" variant="primary" onClick={CreateTrasport}>
                    New Transport
                  </Button>
                </Col>
              </Row>
              <Table striped className="data-table">
                <TableHeader />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </Main>
  );
};

export default TrasportList;
